<template>
	<ion-spinner
		v-if="status === 'checking'"
		name="circular"
		class="h-7 w-7 text-gray-400"
	/>
	<ion-icon
		v-else-if="status === 'available'"
		:icon="checkmarkCircleOutline"
		class="h-7 w-7 text-green-500"
	/>
	<ion-icon
		v-else-if="status === 'taken'"
		:icon="closeCircleOutline"
		class="h-7 w-7 text-red-500"
	/>
	<ion-icon v-else :icon="ellipseOutline" class="h-7 w-7 text-gray-500" />
</template>

<script setup lang="ts">
	import { IonIcon, IonSpinner } from "@ionic/vue";
	import {
		checkmarkCircleOutline,
		closeCircleOutline,
		ellipseOutline,
	} from "ionicons/icons";
	import type { UsernameAvailabilityStatus } from "@/composables/auth/useUsernameAvailability";

	defineProps<{
		status: UsernameAvailabilityStatus;
	}>();
</script>
